<template>
  <div class="container">
    <content-title :nav="nav"></content-title>
    <el-form :inline="true" >
        <el-form-item label="名称">
            <el-input v-model="query.name" placeholder="输入名称"></el-input>
        </el-form-item>
        <el-form-item label="状态">
            <el-select v-model="query.status" placeholder="选择" clearable>
            <el-option label="正常" :value="0"></el-option>
            <el-option label="冻结" :value="2"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button  type="primary" @click="getList(1)">搜索</el-button>
        </el-form-item>
        <el-form-item>
            <el-button v-permission="'addCooperator'" type="primary" @click="add">新增</el-button>
        </el-form-item>
    </el-form>
   
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #type="{ row }">
        <div>{{ type[row.type] }}</div>
        <el-tag v-if="row.status == 0" type="success" size="small">正常</el-tag>
        <el-tag v-if="row.status == 2" type="danger" size="small">冻结</el-tag>
      </template>
      <template #time="{ row }">
        <div>
            开始：{{row.start_time}}
        </div>
        <div>
            结束：{{row.end_time}}
        </div>
      </template>
      <template #handle="{ row }">
        <el-button size="small" type="success" @click="update(row)"
          >编辑</el-button
        >
         <el-button size="small" type="primary" @click="details(row)"
          >详情</el-button
        >
        <el-button v-if="row.status === 0" size="small" type="danger" @click="updateStatus(row,2)"
          >冻结</el-button
        >
         <el-button v-if="row.status === 2"  size="small" type="success" @click="updateStatus(row,0)"
          >解冻</el-button
        >

      </template>
    </auto-table>
    <investAdd @success="getList" ref="AddorEdit"></investAdd>
  </div>
</template>

<script>
import investAdd from './components/investAdd/index.vue'
export default {
  components: {
    investAdd,
  },
  data() {
    return {
      nav: { firstNav: "设备投资管理", secondNav: "投资人" },
      DataList: [],
     query:{
       name:'',
      type:'',
     },
      type: {
        device_invest:'设备投资人'
      },
      Option: [
        { name: "名称", value: "title" },
        { name: "联系人", value: "name" },
        { name: "联系电话", value: "phone" },
        { name: "类型", value: "type", type: "custom" },
         { name: "主理时间", value: "time", type: "custom" ,width:"200"},
        { name: "城市", value: "city" },
        { name: "创建时间", value: "create_time" },
        { name: "操作", value: "handle", type: "custom", width: "300px" },
      ],
      Total: 0,
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    details(row){
      this.$router.push({name:'deviceInvestD',query:{cid:row.id,id:row.admin_id}});
    },
    add() {
      this.$refs.AddorEdit.open();
    },
    update(row) {
      this.$refs.AddorEdit.open(row);
    },
    userDetail(row) {
      this.$router.push({ name: "userDetails", params: { id: row.user_id } });
    },
     updateStatus(row,status){
      this.$axios({
        url: "/user/cooperator/update",
        data: {
          id:row.id,
          status
        },
        method:"post"
      }).then((res) => {
       this.getList(1)
      });
    },
    //列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/cooperator/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          title:this.query.name || null,
           status:this.query.status,
          types:'device_invest',
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>